import React, { useMemo, useRef, useState } from 'react';
import Border, { BorderType } from '../menu/border';
import { ITEM_STATS, ItemName, ItemStats } from './item-types';
import './index.css';
import ItemTooltip from './item-tooltip';

export interface ItemProps {
    itemName: ItemName;
}

const Item: React.FC<ItemProps> = ({ itemName }) => {

    const itemStats: ItemStats = useMemo(() => { return ITEM_STATS[itemName] }, [itemName]);
    const [showTooltip, setShowTooltip] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = () => {
        timerRef.current = setTimeout(() => setShowTooltip(true), 150);
    };

    const handleMouseLeave = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setShowTooltip(false);
    };
    return (
        <div className='item'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <Border type={itemStats.isWeapon ? BorderType.Weapon : BorderType.Default} rarity={itemStats.rarity} warning={itemStats.warning} >
                <img className='item-image'
                    src={`/resources/items/${itemName}.png`}
                    alt={itemStats.name}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = '/resources/missing_art.png';
                    }}
                />
            </Border >
            {showTooltip && <ItemTooltip itemStats={itemStats} />}
        </div>
    );
};

export default Item;